import React from "react"
import { Grid, Button } from "semantic-ui-react"
import { Link, Redirect } from "react-router-dom"
import { Prompt, AskForConfirmation } from "uikit"
//TODO: Duplicate of Account/WorksheetTypes/Footer footer.
export class Footer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      noPrompt: false,
      showConfirmation: false,
      deleteSucceeded: false
    }
  }

  handleDelete = async () => {
    this.setState({
      noPrompt: true
    })
    this.setState(
      {
        showConfirmation: false,
        deleteSucceeded: true
      },
      this.props.onDelete
    )
  }
  render = () => {
    const { isNew, submitLabel, onSubmit, isModified, deleteLabel } = this.props

    if (this.state.deleteSucceeded) {
      return <Redirect to="/organize/income+benefits" />
    }

    return (
      <>
        {!!this.props.error ? (
          <Grid.Row style={{ background: "red", color: "white" }}>
            <Grid.Column textAlign="center">{this.props.error}</Grid.Column>
          </Grid.Row>
        ) : null}
        <Grid.Row style={{ borderTop: "1px solid #ccc" }} columns={2}>
          <Grid.Column textAlign="left" style={{ paddingLeft: "2em" }}>
            {isNew ? (
              <Link to="/organize/income+benefits">
                <Button
                  basic
                  content="Cancel"
                  type="button"
                  color="blue"
                  data-testid="cancel"
                />
              </Link>
            ) : (
              <Button
                data-testid={`${deleteLabel
                  .toLowerCase()
                  .split(" ")
                  .join("-")}`}
                basic
                type="button"
                color="red"
                onClick={() => this.setState({ showConfirmation: true })}
              >
                {deleteLabel}
              </Button>
            )}
            {this.state.showConfirmation ? (
              <AskForConfirmation
                onYes={this.handleDelete}
                onNo={() => this.setState({ showConfirmation: false })}
                header="Are You Sure?"
                render={() => (
                  <span>
                    If you proceed, you will permanently remove this income.
                    <strong> You cannot undo this action.</strong>
                  </span>
                )}
              />
            ) : null}
          </Grid.Column>
          <Grid.Column textAlign="right" style={{ paddingRight: "2em" }}>
            <Button
              data-testid="submit"
              content={submitLabel}
              onClick={onSubmit}
              primary
              type="button"
            />
            <Prompt when={isModified} />
          </Grid.Column>
        </Grid.Row>
      </>
    )
  }
}

Footer.defaultProps = {
  deleteLabel: "Delete",
  submitLabel: "Yes"
}
